import { forwardRef, type ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom-v5-compat';
import { Link as MuiLink } from '@material-ui/core';
import cx from 'classnames';

import styles from './styles.module.css';

interface Props {
  className?: string;
  to?: string;
  href?: string;
  target?: string;
  invertUnderline?: boolean;
  children: ReactNode;
}

const CustomLink = forwardRef<HTMLAnchorElement, Props>(
  ({ className, to, href, children, invertUnderline, ...restProps }, ref) => {
    return to ? (
      <RouterLink
        className={cx(styles.root, className, {
          [styles.invertUnderline]: invertUnderline,
        })}
        ref={ref}
        to={to}
        {...restProps}
      >
        {children}
      </RouterLink>
    ) : (
      <MuiLink
        className={cx(styles.root, className, {
          [styles.invertUnderline]: invertUnderline,
        })}
        ref={ref}
        href={href}
        underline="always"
        {...restProps}
      >
        {children}
      </MuiLink>
    );
  }
);

export default CustomLink;
